
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/how-zenyum-works",
      function () {
        return require("private-next-pages/[lng]/how-zenyum-works.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/how-zenyum-works"])
      });
    }
  